/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 08/05/2025 08:08
 *
 */

import { AoPathFactory } from './ao-path.factory';
import { Factory } from '@infodata-group/inf-commons';
import { AoPathBbx } from '../../model/path/ao-path-bbx';
import { BoPathBbxInterface } from '../../interface/back-office/path/bo-path-bbx.interface';
import { PathPointBbx } from '../../model/path/path-point/path-point-bbx';

export class AoPathBbxFactory
  extends AoPathFactory
  implements Factory<AoPathBbx>
{
  public override build(o: BoPathBbxInterface): AoPathBbx {
    const paths: PathPointBbx[] = o.trj.map((i) => new PathPointBbx(i));
    const pathBbx = new AoPathBbx(this._id, this._date, paths);
    pathBbx.generateMarkers();
    try {
      pathBbx.generatePolyline(this._settingsService);
    } catch (e) {
      console.error(e);
    }
    return pathBbx;
  }

  public override getApi(): string {
    return `trajet/`;
  }
}
